export var LorebookSelectionSort;
(function (LorebookSelectionSort) {
    LorebookSelectionSort["Latest"] = "latest";
    LorebookSelectionSort["Oldest"] = "oldest";
})(LorebookSelectionSort || (LorebookSelectionSort = {}));
function getCreatedAtTimestamp(lorebook) {
    const createdAt = lorebook.createdAt ?? lorebook.created_at;
    if (typeof createdAt === "number")
        return createdAt;
    if (typeof createdAt !== "string")
        return 0;
    const timestamp = new Date(createdAt).getTime();
    return Number.isNaN(timestamp) ? 0 : timestamp;
}
export function filterLorebooksBySearch(lorebooks, query) {
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery)
        return lorebooks;
    return lorebooks.filter((lorebook) => {
        return (lorebook.name?.toLowerCase().includes(normalizedQuery) ||
            lorebook.description?.toLowerCase().includes(normalizedQuery) ||
            lorebook.creator_username?.toLowerCase().includes(normalizedQuery));
    });
}
export function sortLorebooksByCreatedAt(lorebooks, sort) {
    return [...lorebooks].sort((lorebookA, lorebookB) => {
        const diff = getCreatedAtTimestamp(lorebookA) - getCreatedAtTimestamp(lorebookB);
        return sort === LorebookSelectionSort.Latest ? -diff : diff;
    });
}
export function getDisplayLorebookData(stateData, filteredData, selectedLorebookId) {
    if (!filteredData)
        return null;
    if (!selectedLorebookId)
        return filteredData;
    const selectedLorebook = stateData?.find((lorebook) => lorebook.id === selectedLorebookId);
    if (!selectedLorebook)
        return filteredData;
    const isSelectedInFiltered = filteredData.some((lorebook) => lorebook.id === selectedLorebookId);
    if (isSelectedInFiltered)
        return filteredData;
    return [selectedLorebook, ...filteredData];
}
